var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"carousel"},_vm._l((_vm.waiters),function(waiter,key){return _c('div',{key:key,staticClass:"d-flex flex-column align-center item",class:{
        selected: _vm.selectedWaiterId === waiter.id,
      },attrs:{"data-cy":`waiter-${key}`},on:{"click":() => _vm.onWaiterPick(waiter.id)}},[_c('v-avatar',{attrs:{"size":"64"}},[_c('img',{class:{
            'with-border': _vm.selectedWaiterId === waiter.id,
          },attrs:{"src":_vm.getPhotoUrl(waiter),"alt":waiter.name}})]),_c('span',{staticClass:"pt-3 tp-text-label black--text"},[_vm._v(_vm._s(waiter.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }